'use client';

import React, { useMemo } from 'react';
import { Flex, GridItem, Text } from '@skin-seoul/design-system';
import { createReviewStatsMap, getPriceProductBasicInfo, getProductType, useProductService, useRegionCurrency } from '@skin-seoul/service';
import { useReviewService } from '@skin-seoul/service';
import { ProductStockStatus } from '@skin-seoul/service';
import ProductCard from '@/components/products/ProductCard';
import type { Currency } from '@skin-seoul/service';
import { ProductGrid } from '../../components/ProductGrid';
import { shuffle } from 'es-toolkit';
type BestSellersListProps = {
  currency: Currency;
};
const BestSellersList = () => {
  const {
    currency
  } = useRegionCurrency();
  const {
    useGetProductsCollections
  } = useProductService();
  const {
    useGetReviewStatistics
  } = useReviewService();
  const {
    data
  } = useGetProductsCollections({
    collectionName: 'skinseoulselects',
    limit: 50,
    stockStatus: ProductStockStatus.instock,
    currency
  });
  const products = useMemo(() => {
    return data?.products?.length ? shuffle(data.products).slice(0, 5) : [];
  }, [data]);
  const {
    data: reviewStats
  } = useGetReviewStatistics({
    productIds: products.map(product => product.productId).join(',')
  });
  const reviewStatsMap = useMemo(() => createReviewStatsMap(reviewStats), [reviewStats]);
  if (products.length === 0) {
    return <Flex width="100%" justifyContent="center" alignItems="center" padding="60px 0">
        <Text color="neutral.60" textStyle="body2" fontWeight="medium" textAlign="center">
          Currently the Best Seller Collection is Empty
        </Text>
      </Flex>;
  }
  return <ProductGrid data-sentry-element="ProductGrid" data-sentry-component="BestSellersList" data-sentry-source-file="SkinSeoulSelectsList.tsx">
      {products.map(product => {
      const lowestPriceProductInfo = getPriceProductBasicInfo(product);
      const productType = getProductType(product);
      const productReviewStats = reviewStatsMap[product.productId];
      return <GridItem key={product.productId}>
            <ProductCard key={product.productId} href={product.productLink} name={product.name} brand={product.brand} productImage={product.productImageUrls[0]} sku={product.sku} currency={product.currency} originalPrice={lowestPriceProductInfo.originalPrice} salePrice={lowestPriceProductInfo.salePrice} rating={productReviewStats?.averageRate} reviewCount={productReviewStats?.totalReviews} productType={productType} productId={product.productId.toString()} category={product.category} />
          </GridItem>;
    })}
    </ProductGrid>;
};
export default BestSellersList;